export const RemoveSubPageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      strokeWidth="1.6"
    >
      <path
        d="M13.875 10.3333V16.1667M10.125 10.3333V16.1667M6.375 7V16.8333C6.375 17.7668 6.375 18.2331 6.57936 18.5897C6.75913 18.9033 7.04576 19.1587 7.39856 19.3185C7.79925 19.5 8.32406 19.5 9.3721 19.5H14.6279C15.6759 19.5 16.2 19.5 16.6007 19.3185C16.9535 19.1587 17.2411 18.9033 17.4208 18.5897C17.625 18.2335 17.625 17.7675 17.625 16.8359V7M6.375 7H8.25M6.375 7H4.5M8.25 7H15.75M8.25 7C8.25 6.22343 8.25 5.83534 8.39273 5.52905C8.58303 5.12067 8.9478 4.79602 9.40723 4.62687C9.7518 4.5 10.1889 4.5 11.0625 4.5H12.9375C13.8111 4.5 14.248 4.5 14.5925 4.62687C15.052 4.79602 15.4169 5.12067 15.6072 5.52905C15.7499 5.83534 15.75 6.22343 15.75 7M15.75 7H17.625M17.625 7H19.5"
        stroke="#E64343"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
